// extracted by mini-css-extract-plugin
module.exports = {"root":"info-list-item_root__M5YKo","title":"info-list-item_title__NvqlP"};